import React from 'react';
import { testimonials } from '../data/testimonials';

export default function Testimonials() {
  return (
    <section className="section testimonials-section">
      <div className="section-header">
        <h2>Lo que dicen las familias</h2>
        <p>Historias reales de quinceañeras que organizaron su fiesta con MisXV.com.mx</p>
      </div>
      <div className="testimonials-grid">
        {testimonials.map((t) => (
          <blockquote className="testimonial-card" key={t.id}>
            <p>&ldquo;{t.quote}&rdquo;</p>
            <footer>
              <img src={`https://picsum.photos/seed/${t.avatarSeed}/80/80`} alt={t.name} />
              <div>
                <strong>{t.name}</strong>
                <span>{t.event}</span>
              </div>
            </footer>
          </blockquote>
        ))}
      </div>
    </section>
  );
}
